document.addEventListener('DOMContentLoaded', function () {

  function filterImagesByVariant(variantTitle) {
    if (!variantTitle) return;

    const selected = variantTitle.toLowerCase();

    document.querySelectorAll('.product__media-item').forEach(item => {
      const img = item.querySelector('img');
      const alt = img?.alt?.toLowerCase() || '';

      if (alt.includes(selected)) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }

  // Listen for Shopify variant change (Horizon compatible)
  document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant;
    if (variant) {
      filterImagesByVariant(variant.title);
    }
  });

  // Run on page load (default selected variant)
  const initialVariant = document.querySelector('input[name="id"]:checked');
  if (initialVariant) {
    const variantTitle = initialVariant.dataset.variantTitle;
    filterImagesByVariant(variantTitle);
  }

});